import * as React from 'react'

import { Button } from 'reactstrap'

import TerminationFormData from '../TerminationFormData.interface'
import TerminationFormDataUpdate from '../TerminationFormDataUpdate.type'

import terminationReasons from 'src/utils/termination-reason'

const moment = require('moment')
const compact = require('lodash/compact')

export interface TerminationFinalConfirmationProps {
  terminationForm: TerminationFormData
  statusCallback: TerminationFormDataUpdate
}

class TerminationFinalConfirmation extends React.PureComponent<TerminationFinalConfirmationProps> {
  handleSubmit() {
    const { terminationForm } = this.props
    this.props.statusCallback('SUBMITTING', terminationForm)
  }

  get employeeName() {
    const { terminationForm } = this.props

    const names = [terminationForm.employee.firstName, terminationForm.employee.lastName]
    return compact(names).join(' ')
  }

  renderRow(title, value) {
    return (
      <tr>
        <th className="text-uppercase">{title}:</th>
        <td>{value}</td>
      </tr>
    )
  }

  render() {
    const { terminationForm } = this.props

    return (
      <div className="p4">
        <h5 className="text-justify mb-3">Check the data and confirm to submit</h5>
        
        <table className="w-100">
          <tbody>
            {this.renderRow('Employee', this.employeeName)}
            {this.renderRow('Voluntary', terminationForm.voluntary ? 'Yes' : 'No')}
            {this.renderRow('Eligible for rehire', terminationForm.eligibleForRehire ? 'Yes' : 'No')}
            {this.renderRow('Termination date', moment(terminationForm.lastDayOfWork).format('MM/DD/YYYY'))}
            {this.renderRow('Termination reason', terminationReasons[terminationForm.reason!])}
            {!!terminationForm.comments && this.renderRow('Comments', terminationForm.comments)}
          </tbody>
        </table>
        <Button color="primary" className="btn-block mt-4" onClick={e => this.handleSubmit()}>
          Submit
        </Button>
      </div>
    )
  }
}

export default TerminationFinalConfirmation


// WEBPACK FOOTER //
// ./src/routes/terminations/termination-flow/components/TerminationFinalConfirmation.component.tsx